import React ,{useEffect} from "react";

import i18next from "i18next";
import { useTranslation } from "react-i18next";

import { useSelector, useDispatch } from "react-redux";

import {
  Grid,
  Typography,
  Avatar,
  Box,
  IconButton,
  Tab,
  useMediaQuery,
} from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";

import History from "./history";
import RegisterNotification from "../OnBoarding/RegisterNotification/RegisterNotification";

import UserProfile from "../../sections/auth/UserProfile";

import Stats from "./stats";
import Header from "../Header";
import AlertNotification from "./AlertsNotifications";
import SectionHeading from "./SectionHeading";
import TourCard from "./TourCard";
import SideNavbar from "./SideNavbar";
import Actions from "./Actions";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { GetProfileImages } from "../DocumentDetails/slice";
import SvgIconStyle from "../../components/SvgIconStyle";
import {
  platformOptions,
  stats,
  dashboardMenu,
  donationDashboardMenu,
  donationFilterMenu,
  donationHistoryFilterMenu,
} from "../../data";

import {
  setDonationId,
  addDonation,
  setDonationType,
  getDonation,
} from "../DonationView/slice";
import {
  setTileData,
  getMyActiveDonation,
  setSelectedDonation,
  setMyActiveDonationsPage,
} from "./slice";
import { getUserEntity } from "../../redux/features/authSlice";
import DonationList from "./DonationList";

import Donations from "../Donations";

import ActionDate from "./Actions/ActionDate";
import { getMyCollection } from "../CreateCollection/slice";
import {
  ComponentType,
  DEFAULT_AVATAR_URL,
  DonationStatus,
  EntityType,
} from "../../common/enum";
import ManageBranch from "../../components/ManageBranch/ManageBranch";
import ManageManagers from "./ManageManagers";
import Snackbar from "../../components/Snackbar";
import { setSnackbarOpen } from "../AdminView/adminSlice";
import CollectorDonationView from "./CollectorDonationView";
import { useCollection } from "./Actions/ActionDate/useCollection";
import { TabList } from "@mui/lab";
import { useTheme } from "@mui/material/styles";
import { useLocation, useNavigate } from "react-router-dom";
const DEFAULT_FILTER = "select";
const style = {
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  maxWidth:"100%"
};

const dashboardStyle = {
  backgroundPosition: "left top",
  backgroundRepeat: "no-repeat",
  backgroundImage: "url(/static/dashboard/left-top-bg.png)",
};
const avataStyles = { bgcolor: "#E4F2E8", width: "58px", height: "58px" };

const svgIconStyle = { color: "black", width: "40px", height: "40px" };

const Dashboard = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("lg"));
  const [collection, setCollection] = React.useState(null);
  const [donationTabvalue, setDonationTabValue] = React.useState(
    donationDashboardMenu[0].link
  );
  const [donationStatus, setDonationStatus] = React.useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [menuTitle, setMenuTitle] = React.useState("myDonation");
  const [selectedIndex, setSelectedIndex] = React.useState(1);
  const [donationTitle, setDonationTitle] = React.useState("Selecione...");
  const [donationHistoryTitle, setDonationHistoryTitle] = React.useState("Selecione...");
  const [donations, SetMyActiveDonations] = React.useState(null);
  const [animal, Setanimal] = React.useState(null);

  const open = Boolean(anchorEl);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {
    translate,
    auth,
    dashboardInfo: {
      dashboardTab = dashboardMenu[0].title,
      myActiveDonations,
      myActiveDonationsOffSet,
      myActiveDonationsLimit,
      myActiveDonationsTotalCount,
      entityProfileSelect,
    },
    adminDashboard: { snackBarOpen, snackBarMessage, snackBarSeverity },
  } = useSelector((state) => state);
  const loaction = useLocation();
  const { userId, entityId, managerName } = auth.user || {};
  const { entity, address ,parentEntity} = auth.profile || {};

  const location = useLocation();

  const loadData = async () => {
    dispatch(setTileData(getTileData()));

    dispatch(getUserEntity(entityId))
      .unwrap()
      .then((resp) => {
        getDonations(resp.entity.entityType);
      });
  };

  const getDonations = React.useCallback(
    (val, status = DonationStatus.new, isAnimal = "") => {
    if(location.pathname === "/dashboard"){
      const data = {
        offset: 0,
        limit: 8 ,
        entityType:
          val === EntityType.donorDistributor ? entityProfileSelect : val,
        entityId: userId,
      };
      if (
        val === EntityType.donor ||
        (entityProfileSelect === EntityType.donor &&
          val === EntityType.donorDistributor)
      ) {
        data["status"] = status;
        data["isAnimal"] = isAnimal;
      }
       dispatch(getMyActiveDonation(data))
      .unwrap()
      .then((res) => {
        SetMyActiveDonations(res?.donationDetails || []);
      });

      dispatch(setMyActiveDonationsPage(1));
      }
    },
    [dispatch, entityProfileSelect]
  );

  const handleDonationChange = (event, newValue) => {
    setDonationTabValue(newValue);
    navigate(newValue);

    // reset visual do filtro
    setDonationStatus(null);
    setDonationTitle("Selecione...");
    setDonationHistoryTitle("Selecione...");
  };

  const handleDonationMenu = (event, title) => {
    setAnchorEl(event.currentTarget);
    setMenuTitle(title);
    // if (title === donationDashboardMenu[0].title) {
    //   setDonationHistoryTitle(donationHistoryFilterMenu[0].title);
    // } else {
    //   setDonationTitle(donationFilterMenu[0].title);
    // }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

const handleMyDonationFilter = (value, title, isAnimal) => {
  setDonationStatus(value);
  setDonationTitle(title);
  setAnchorEl(null);
  Setanimal(isAnimal)

  // getDonations(EntityType.donor, value, isAnimal);
};

const handleHistoryDonationFilter = (value, title) => {
  setDonationStatus(value);
  setDonationHistoryTitle(title);
  setAnchorEl(null);

  // getDonations(EntityType.donor, value, "");
};

  const getTileData = () => {
    let payload = stats;
    // payload[1]["number"] =
    //   myActiveDonations.length > 0 ? myActiveDonationsTotalCount : 0;
    return payload;
  };
  

  const [profilepictureuri, setprofilepictureuri] = React.useState("");

  React.useEffect(() => {
  if (location.pathname === "/dashboard") {
    loadData();
  }
}, [location.pathname]);

  React.useEffect(() => {
    // const loadData = async () => {
    //   dispatch(setTileData(getTileData()));
    //   dispatch(getUserEntity(entityId))
    //     .unwrap()
    //     .then((resp) => {
    //       getDonations(resp.entity.entityType);
    //     });
    // };
    // loadData();

     if(entity?.profilePicture != "string" && entity?.profilePicture != null &&  entity?.profilePicture != undefined){
       dispatch(GetProfileImages(entity?.profilePicture))
       .unwrap()
        .then((response) => {
           if(response.isActive != null){
            setprofilepictureuri(response.isActive);
          }else{
            setprofilepictureuri(DEFAULT_AVATAR_URL);
          }
        })
    }
    
  }, [entity?.profilePicture]);

  React.useEffect(() => {
    i18next.changeLanguage(translate);
  }, [translate]);

  const collectionDetails = (value) => {
    if (value) {
      setCollection(value);
    }
  };

  const onClose = React.useCallback(() => {
    dispatch(setSnackbarOpen(false));
  }, [dispatch]);

  const entityName = React.useMemo(() => {
    if (entity && entity?.isParentEntity === false) {
      
      return parentEntity?.entityName;
    }
    return entity?.entityName;
  }, []);
  const navigate = useNavigate();

  const handleEvent = () => {
    // navigate("/dashboard");
    if (location.pathname === "/dashboard") {
      navigate("/dashboard"); // this line of code prevents browser going back. if you don't navigate to any pages of app in callback function using react-router navigate() function, by default any event will occure when click on browser back button and back button is disabled.
    }
  };

  const outerTabValue = React.useMemo(() => {
    if (donationDashboardMenu.find((item) => item.link === location.pathname)) {
      if (entityProfileSelect === EntityType.distributor) {
        navigate(
          loaction.pathname.slice(0, location.pathname.lastIndexOf("/"))
        );
      }
      return loaction.pathname.slice(0, location.pathname.lastIndexOf("/"));
    } else {
      return loaction.pathname;
    }
  }, [location.pathname, entityProfileSelect]);

  const innerTabValue = React.useMemo(() => {
    if (
      (entity?.entityType === EntityType.donor ||
        entityProfileSelect === EntityType.donor) &&
      location.pathname === "/dashboard/donations"
    ) {
      navigate(donationDashboardMenu[0].link);
      return donationDashboardMenu[0].link;
    } else {
      return location.pathname;
    }
  }, [entity, entityProfileSelect, location.pathname]);

  React.useEffect(() => {
    window.addEventListener("popstate", handleEvent);

    return () => window.removeEventListener("popstate", handleEvent);
  }, []);

  return (
    <div style={dashboardStyle} >
      <Header t={t} />
      <TabContext 
        value={outerTabValue}
        orientation="vertical"
        indicatorColor={""}
        centered
      >
        <Grid
          container
          sx={{
            padding: "2%",
            justifyContent: "space-between",
          }}
        >
          <Grid 
            item
            xs={12}
            md={3}
            lg={3}
            xl={3}
            sx={{
              // borderBottom: 1,
              borderColor: "divider",
            }}
          >
            <Grid
              sx={{
                display: "flex",
                alignItems: "center",
                marginX: "auto",
                paddingBottom: "24px",
              }}
            >
              <Avatar
                alt={`Entidade ${userId === entityId ? managerName : entityName}`}
                src={
                  entity?.profilePicture !== "string"
                    ? profilepictureuri
                    : DEFAULT_AVATAR_URL
                }
                sx={{
                  width: 55,
                  height: 55,
                  backgroundColor: "green",
                  "& img": {
                    height:
                      entity?.profilePicture === "string" ||
                      entity?.profilePicture === null
                        ? "100%"
                        : "100%",
                    width:
                      entity?.profilePicture === "string" ||
                      entity?.profilePicture === null
                        ? "100%"
                        : "100%",
                  },
                }}
              />

              <Box sx={{ paddingLeft: "15px" , width:"100%" , }}>
                <Typography sx={{ fontFamily: "Sitka Heading" }}>
                  <span>{t("hello")},</span>
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Sitka Heading",
                    fontWeight: "600",
                    fontSize: "16px",
                    // wordWrap: "anyWhere",
                    mb:  managerName != null || entity?.isParentEntity === false ? 0 : 3,
                    "@media only screen and (min-width:900px) and (max-width:1320px)":
                      {
                        // textOverflow: "ellipsis",
                        // overflow: "hidden",
                        // width: "80%",
                        // whiteSpace: "nowrap",
                        whiteSpace: "normal",  
                        wordBreak: "break-word", 
                        overflowWrap: "anywhere"
                      },
                  }}
                >
                  {userId !== entityId ? managerName :  entity?.entityName}
                </Typography>
                {entity?.isParentEntity === false  && (
                  <Typography
                    color={"primary"}
                    sx={{
                      fontFamily: "Sitka Heading",
                      fontWeight: "600",
                    }}
                  >
                    {" "}
                    
                    {userId !== entityId ? entity?.entityName : entityName}
                  </Typography>
                )}
                {managerName != null && entity?.isParentEntity === true &&(
                  <Typography
                    color={"primary"}
                    sx={{
                      fontFamily: "Sitka Heading",
                      fontWeight: "600",
                    }}
                  >
                    {" "}
                    
                    {userId !== entityId ? entity?.entityName : entityName}
                  </Typography>
                )}
              </Box>
            </Grid>
            <SideNavbar t={t} />
            <TourCard t={t} entityType={entity?.entityType} auth={auth} profileSelected = {entityProfileSelect}/>
          </Grid>
          <Grid item xs={12} md={9} lg={9} xl={9}>
            <TabPanel value={dashboardMenu[0].link}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={8}>
                  <Stats t={t} donations={donations}/>
                </Grid>
                {entity.isGroupEntity && entity.isParentEntity ? null : (
                  <Grid item xs={12} md={4}>
                    <AlertNotification t={t} />
                  </Grid>
                )}
              </Grid>
            </TabPanel>
            <TabPanel  value={dashboardMenu[1].link}>
              <Grid container spacing={2}>
                {entity?.entityType !== EntityType.distributor && (
                  <Grid item xs={12} md={12}>
                    {(entity?.entityType === EntityType.donor ||
                      entityProfileSelect === EntityType.donor) && (
                      <>
                         <Typography
                          variant="h1"
                          style={{
                            marginBottom: "5px",
                            fontSize: "24px",
                            fontFamily: "Sitka Heading",
                          }}
                        >
                          {t("donations")}
                        </Typography>
                        <Typography
                          variant="h2"
                          style={{
                            marginBottom: "15px",
                            fontSize: "small",
                            fontFamily: "Poppins",
                            fontWeight: 600,
                            color: "#6E6E6E",
                          }}
                        >
                          {t("donationDonorSubHeading")}
                        </Typography>
                        <TabContext value={innerTabValue}  >
                          
                          <Box sx={{ borderBottom: 1, borderColor: "divider" }} >
                            <TabList
                              onChange={handleDonationChange}
                              aria-label="lab API tabs example"
                              variant="scrollable"
                                  scrollButtons="auto"
                                  allowScrollButtonsMobile
                            >
                              {donationDashboardMenu.map((item) => (
                                <Tab
                                  key={item.title}
                                 
                                  label={
                                    <React.Fragment>
                                      {item.title === "myDonation" && (
                                        <Typography
                                      
                                          fontWeight={"600"}
                                          fontSize={16}
                                          fontFamily={"Sitka Heading"}
                                          color={"#212B36"}
                                          sx={{ wordBreak: "break-all" , textAlignLast:"left"}}
                                        >
                                          {"Ativas"}:{" "}
                                          <span className="mydonationscanal tab1Estado">
                                            {donationTitle === "Selecione..." ? "Selecione..." : t(donationTitle)}
                                          </span>
                                        </Typography>
                                       
                                     
                                      )}
                                      {item.title === "history" && (
                                        <Typography
                                          fontWeight={"600"}
                                          fontSize={16}
                                          fontFamily={"Sitka Heading"}
                                          color={"#212B36"}
                                          sx={{ wordBreak: "break-all" , textAlignLast:"left"}}
                                        >
                                          {t(`history`)}:{" "}
                                          <span className="mydonationscanal">
                                            {donationHistoryTitle === "Selecione..."
                                              ? "Selecione..."
                                              : t(donationHistoryTitle)}
                                          </span>
                                        </Typography>
                                      )}{" "}
                                    </React.Fragment>
                                  }
                                  value={item.link}
                                  onClick={(event) =>
                                    handleDonationMenu(event, item.title)
                                  }
                                  icon={<ArrowDropDownIcon />}
                                  iconPosition="end"
                                  sx={{ maxWidth:"400px"}}
                                />
                              ))}
                            </TabList>
                          </Box>
                          <Menu
                            
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            MenuListProps={{
                              "aria-labelledby": "basic-button",
                            }}
                          >
                            {menuTitle === "myDonation"
                              ? donationFilterMenu.map((item, index) => (
                                  <MenuItem
                                  
                                     onClick={() => {
                                        console.log("CLIQUEI");
                                        handleMyDonationFilter(item.value, item.title, item.isAnimal);
                                      }}
                                    key={item.title}
                                  >
                                    {t(`${item.title}`)}
                                  </MenuItem>
                                ))
                              : donationHistoryFilterMenu.map((item, index) => (
                                  <MenuItem
                                    onClick={() =>
                                      handleHistoryDonationFilter(
                                        item.value,
                                        item.title
                                      )
                                    }
                                    key={item.title}
                                  >
                                    {t(`${item.title}`)}
                                  </MenuItem>
                                ))}
                          </Menu>
                          <TabPanel
                            className="nananannan"
                            // sx={{ [theme.breakpoints.down("sm")]: { p: 0 } }}
                            sx={{ padding: "24px 0"}}
                            value={donationDashboardMenu[0].link}
                          >

                            {donationStatus === null ? (
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%",
                                mt: "5%",
                              }}
                            >
                              <Avatar sx={avataStyles}>
                                <SvgIconStyle src="/static/dashboard/box.svg" sx={svgIconStyle} />
                              </Avatar>
                              <Box sx={{ paddingLeft: "10px" }}>
                                <Typography sx={{ marginTop: "10px" }}>
                                 Selecione o que pretende visualizar
                                </Typography>
                              </Box>
                            </Box>
                          ) : (
                            <Donations donationStatus={donationStatus} t={t} donorfilter={donationTitle} donationHistoryTitle={donationHistoryTitle} isAnimals={animal}/>
                          )}

                          
                          </TabPanel>
                          <TabPanel
                            sx={{ [theme.breakpoints.down("sm")]: { p: 0 } }}
                            value={donationDashboardMenu[1].link}
                          >
                            {donationStatus === null ? (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "100%",
                                  mt: "5%",
                                }}
                              >
                                  <Avatar sx={avataStyles}>
                                    <SvgIconStyle src="/static/dashboard/box.svg" sx={svgIconStyle} />
                                  </Avatar>
                                  <Box sx={{ paddingLeft: "10px" }}>
                                    <Typography sx={{ marginTop: "10px" }}>
                                    Selecione o que pretende visualizar
                                    </Typography>
                                  </Box>
                              </Box>
                              ) : (
                                <Donations donationStatus={donationStatus} t={t} donorfilter={donationTitle} donationHistoryTitle={donationHistoryTitle} isAnimals={animal}/>
                              )}
                                                      
                          </TabPanel>
                        </TabContext>
                      </>
                    )}
                  </Grid>
                )}
                {
                (entity?.entityType === EntityType.distributor ||
                  entityProfileSelect === EntityType.distributor ||
                  entity?.entityType === EntityType.specialDistributor) && 
                  (
                  <Grid item xs={12} md={12}>
                    <SectionHeading
                      heading="donations"
                      subHeading="donationReceiverSubHeading"
                      t={t}
                      style={{
                        marginBottom: "15px",
                      }}
                    />
                    <CollectorDonationView t={t} />
                  </Grid>
                )}
              </Grid>
            </TabPanel>
            <TabPanel value={dashboardMenu[2].link}>
              {" "}
              <Grid container spacing={2}>
                <Grid item xs={12} md={7}>
                <Typography
                  variant="h1"
                  style={{
                    marginBottom: "15px",
                    fontSize: "24px",
                    fontFamily: "Sitka Heading",
                  }}
                >
                  {t("action")}
                </Typography>
                  <ActionDate collectionDetails={collectionDetails} t={t} />
                </Grid>
                {collection != null ? 
                Object.keys(collection).length != 0 &&
                  <Grid item xs={12} md={5}>
                  <Actions
                    component={ComponentType.AGENDA}
                    setCollectionId={setCollection}
                    collection={collection}
                    t={t}
                  />
                </Grid>
                : ""
                
                }
               
              </Grid>
            </TabPanel>
            <TabPanel value={dashboardMenu[3].link}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={9}>
                <Typography
                  variant="h1"
                  style={{
                    marginBottom: "15px",
                    fontSize: "24px",
                    fontFamily: "Sitka Heading",
                  }}
                >
                  {t("profile")}
                </Typography>
                  <UserProfile t={t} />
                </Grid>
                <Grid item xs={12} md={9}></Grid>
              </Grid>
            </TabPanel>
            <TabPanel value={dashboardMenu[4].link}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                <Typography
                  variant="h1"
                  style={{
                    marginBottom: "15px",
                    fontSize: "24px",
                    fontFamily: "Sitka Heading",
                  }}
                >
                  {t("manageBranches")}
                </Typography>
                  <ManageBranch t={t} />
                </Grid>
              </Grid>
            </TabPanel>
            <TabPanel value={dashboardMenu[5].link}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={9}>
                <Typography
                  variant="h1"
                  style={{
                    marginBottom: "35px",
                    fontSize: "24px",
                    fontFamily: "Sitka Heading",
                  }}
                >
                  {t("manageManagers")}
                </Typography>
                  <ManageManagers t={t} />
                </Grid>
              </Grid>
            </TabPanel>
            <TabPanel value={dashboardMenu[6].link}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={9}>
                <Typography
                  variant="h1"
                  style={{
                    marginBottom: "35px",
                    fontSize: "24px",
                    fontFamily: "Sitka Heading",
                  }}
                >
                  {t("settings")}
                </Typography>
                  <RegisterNotification
                    t={t}
                    currentQuestion={platformOptions}
                    inDashboard={true}
                  />
                </Grid>
                <Grid item xs={12} md={9}></Grid>
              </Grid>
            </TabPanel>
          </Grid>
        </Grid>
      </TabContext>
      <Snackbar
        open={snackBarOpen}
        severity={snackBarSeverity}
        onClose={onClose}
        message={snackBarMessage}
        t={t}
      />
    </div>
  );
};

export default Dashboard;
